const precision2 = num => Number.parseFloat(num).toPrecision(3);
const __script_base__ = {
  name: 'UcProgressCircle',
  props: {
    type: String,
    color: String,
    text: String,
    percentSantiy: String,
    lineWidth: {
      type: Number,
      default: 6
    }
  },
  computed: {
    radius() {
      return 40;
    },
    dash() {
      let {
        parameter
      } = this;
      if (this.type === 'dashboard') {
        parameter = parameter * 0.8;
      }
      const solidLine = precision2(parameter * (this.percentSantiy / 100));
      return `${solidLine} ${this.parameter - solidLine} `;
    },
    parameter() {
      return precision2(2 * (22 / 7) * this.radius);
    },
    gapDash() {
      if (this.type === 'dashboard') {
        const solidLine = precision2(this.parameter * 0.8);
        return `${solidLine} ${this.parameter - solidLine} `;
      }
      return `${this.parameter} 0`;
    },
    initOffset() {
      if (this.type === 'dashboard') {
        return -precision2(this.parameter * (35 / 100));
      }
      return precision2(this.parameter / 4);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "uc-progress isCircle"
  }, [_c("div", {
    staticClass: "uc-progress-sizeExpander"
  }), _vm._v(" "), _c("div", {
    staticClass: "uc-progress-circleWrapper"
  }, [_c("svg", {
    staticClass: "uc-progress-circleSvg",
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100"
    }
  }, [_c("circle", {
    staticClass: "bg",
    attrs: {
      cx: 50,
      cy: 50,
      r: _vm.radius,
      "stroke-width": _vm.lineWidth,
      "stroke-dasharray": _vm.gapDash,
      "stroke-dashoffset": _vm.initOffset
    }
  }), _vm._v(" "), _c("circle", {
    staticClass: "progress",
    style: "stroke: " + _vm.color,
    attrs: {
      cx: 50,
      cy: 50,
      r: _vm.radius,
      "stroke-width": _vm.lineWidth,
      "stroke-dasharray": _vm.dash,
      "stroke-dashoffset": _vm.initOffset
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "uc-progress-circle-text"
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")])])]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Progress/CircleProgress.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);